(ns app.front.ui.visibility-title
  (:require [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]))


(def visibility-icon
  {:internal i/lock
   :public   i/lock-open-fully})


(defn visibility-title [{:keys [visibility tr]} text]
  [:div.flex.justify-between.items-center.w-full.items-center
   [:span.align-middle
    text]
   (when (<sub [:session/authority-user?])
     [:div.ml-2
      [:span.uppercase.text-gray-700.text-base
       (tr [visibility])]
      [cc/icon {:icon        (visibility-icon visibility)
                :class-name  "mx-2"
                :description ""
                :aria-hidden true}]])])
